const s3ErrorRegex = /<Message>([^<])/; // Use regex so we can avoid requiring an XML parser
// If this was only in the browser we _could_ use the DOMParser API

const parseS3Error = xml => {
  const [, error] = s3ErrorRegex.exec(xml);
  return error;
};

module.exports = (uploadToken
/*: UploadToken*/
, file
/*: File*/
, size
/*: number*/
, contentType
/*: string*/
) =>
/*: Promise<any>*/
{
  const {
    uploadUrl
  } = uploadToken;
  return fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
      'Content-Length': size
    }
  }).then(response => {
    if (response.ok) return response; // TODO: Custom Error type for HTTP rejections

    return response.text().then(body => Promise.reject(new Error(`Upload Failed: ${parseS3Error(body)}`)));
  }).catch(err => Promise.reject(err));
};